const LOGO_ICON_COLOR = '#F98E54'
const LOGO_TEXT_COLOR = '#093D65'
const LOGO_SLOGAN_COLOR = '#F98E54'
const BLANK_BLOCK_COLOR = '#fff'
export {
    LOGO_ICON_COLOR,LOGO_SLOGAN_COLOR,LOGO_TEXT_COLOR,BLANK_BLOCK_COLOR,
}